var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00001 6.00019H8.59001L5.29001 2.71019C5.10171 2.52188 4.99592 2.26649 4.99592 2.00019C4.99592 1.73388 5.10171 1.47849 5.29001 1.29019C5.47832 1.10188 5.73371 0.996094 6.00001 0.996094C6.26631 0.996094 6.52171 1.10188 6.71001 1.29019L11.71 6.29019C11.8011 6.38529 11.8724 6.49743 11.92 6.62019C12.02 6.86365 12.02 7.13672 11.92 7.38019C11.8724 7.50294 11.8011 7.61508 11.71 7.71019L6.71001 12.7102C6.61705 12.8039 6.50645 12.8783 6.38459 12.9291C6.26273 12.9798 6.13202 13.006 6.00001 13.006C5.868 13.006 5.73729 12.9798 5.61544 12.9291C5.49358 12.8783 5.38298 12.8039 5.29001 12.7102C5.19628 12.6172 5.12189 12.5066 5.07112 12.3848C5.02035 12.2629 4.99421 12.1322 4.99421 12.0002C4.99421 11.8682 5.02035 11.7375 5.07112 11.6156C5.12189 11.4937 5.19628 11.3831 5.29001 11.2902L8.59001 8.00019H1.00001C0.734796 8.00019 0.480441 7.89483 0.292905 7.70729C0.105369 7.51976 1.23978e-05 7.2654 1.23978e-05 7.00019C1.23978e-05 6.73497 0.105369 6.48062 0.292905 6.29308C0.480441 6.10554 0.734796 6.00019 1.00001 6.00019Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUNext);
export default __webpack_public_path__ + "static/media/U_next.3c3a13900d6a53fb30299938d81e053c.svg";
export { ForwardRef as ReactComponent };